module.exports = __webpack_public_path__ + "static/media/icon-report-print.4b02743b.svg";